<template>
  <v-container v-if="!isMobile">
    <nav>
      <v-app-bar app height="80">
        <v-toolbar-title>
          <v-breadcrumbs :items="items" large></v-breadcrumbs>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <div class="pa-1 mr-1">
          <v-select
            height="42"
            :items="location"
            item-value="_id"
            v-model="locationItem"
            @change="updateLocation"
            hide-details
            :item-text="
              (location) => {
                return location.location;
              }
            "
            prepend-inner-icon="mdi-map-marker"
            solo
            style="font-size: 15px;"
            outlined
            dense
          ></v-select>
        </div>
        <v-md-date-range-picker :presets="presets" opens="right" @change="updateData" class="mr-2">
          <v-card class="pa-2" slot="input" style="outline:1px solid grey;">
            <v-icon color="red darken-2" class="mr-1">
              mdi-clock-outline
            </v-icon>
            <span style="font-size: 15px;">{{ formatDate($store.state.dateTime1) }} - {{ formatDate($store.state.dateTime2) }}</span>
          </v-card>
        </v-md-date-range-picker>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn :loading="loading5" :disabled="loading5" :color="!timer ? 'red' : 'green'" :class="!timer ? 'ma-1 white--text' : 'ma-1 white--text'" @click="(timer = !timer), (loader = 'loading5')" fab small v-bind="attrs" v-on="on">
              <v-icon dark>
                {{ !timer ? "mdi-play" : "mdi-pause" }}
              </v-icon>
            </v-btn>
          </template>
          <span> {{ !timer ? "Enable Auto Refresh Page" : "Disable Auto Refresh Page" }}</span>
        </v-tooltip>
      </v-app-bar>
    </nav>

    <v-row justify="center" align="center" class="mb-10">
      <v-col cols="4" class="df">
        <div class="water-tank" v-if="waterTank.length == 0">
          <p justify="center" align="center">No Data</p>
          <div class="indicator" data-value="75"></div>
          <div class="indicator" data-value="50"></div>
          <div class="indicator" data-value="25"></div>
        </div>

        <div class="water-tank" v-else>
          <div class="liquid" :style="cssProps">
            <p justify="center" align="center">{{ waterPercent.slice(-1)[0].toFixed(2) }}% / 2440ℓ</p>
            <svg class="water" viewBox="0 0 200 100">
              <defs>
                <linearGradient id="waterGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0" style="stop-color:#29ABE2" />
                  <stop offset="0.1643" style="stop-color:#28A6E3" />
                  <stop offset="0.3574" style="stop-color:#2496E6" />
                  <stop offset="0.5431" style="stop-color:#1E7DEA" />
                  <stop offset="0.7168" style="stop-color:#1559F0" />
                  <stop offset="0.874" style="stop-color:#0B2CF7" />
                  <stop offset="1" style="stop-color:#0000FF" />
                </linearGradient>
              </defs>
              <path
                fill="url(#waterGradient)"
                d="
                    M 0,0 v 100 h 200 v -100 
                    c -10,0 -15,5 -25,5 c -10,0 -15,-5 -25,-5
                    c -10,0 -15,5 -25,5 c -10,0 -15,-5 -25,-5
                    c -10,0 -15,5 -25,5 c -10,0 -15,-5 -25,-5
                    c -10,0 -15,5 -25,5 c -10,0 -15,-5 -25,-5
                  "
              />
            </svg>
          </div>

          <div class="indicator" data-value="75"></div>
          <div class="indicator" data-value="50"></div>
          <div class="indicator" data-value="25"></div>

          <div class="label" :style="cssProps" v-if="waterPercent.slice(-1)[0] < 60" style="color: green">{{ waterPercent.slice(-1)[0].toFixed(2) }}%</div>
          <div class="label" :style="cssProps" v-else-if="waterPercent.slice(-1)[0] >= 60 && waterPercent.slice(-1)[0] < 80" style="color: yellow">{{ waterPercent.slice(-1)[0].toFixed(2) }}%</div>
          <div class="label" :style="cssProps" v-else-if="waterPercent.slice(-1)[0] >= 80" style="color: crimson">{{ waterPercent.slice(-1)[0].toFixed(2) }}%</div>
        </div>
      </v-col>

      <v-col>
        <v-col cols="12">
          <v-card class="pa-1">
            <v-container style="display: flex; flex-direction:column; justify-content: space-between;">
              <p align="center">Current Tank Level</p>
              <div style="display: flex; justify-content: space-between;">
                <v-card class="text-center" color="white" dark width="180" max-height="100">
                  <v-card-text>
                    <div style="font-size:12px;color:black;">
                      Recently
                    </div>
                    <div style="font-size:17px;color:black;" v-if="waterTank.length == 0">
                      No Data
                    </div>
                    <div style="font-size:17px;color:black;" v-else>{{ waterConv[0] }}<span style="font-size:15px;color:black;">mm</span></div>
                  </v-card-text>
                </v-card>

                <v-card class="text-center" color="white" dark width="180" max-height="100">
                  <v-card-text>
                    <div style="font-size:12px;color:black;">
                      Filled
                    </div>
                    <div style="font-size:17px;color:black;" v-if="waterTank.length == 0">
                      No Data
                    </div>
                    <div style="font-size:17px;color:black;" v-else>{{ waterPercent.slice(-1)[0].toFixed(2) }}<span style="font-size:15px;color:black;">%</span></div>
                  </v-card-text>
                </v-card>

                <v-card class="text-center" color="white" dark width="180" max-height="100">
                  <v-card-text>
                    <div style="font-size:12px;color:black;">
                      Volume
                    </div>
                    <div style="font-size:17px;color:black;" v-if="waterTank.length == 0">
                      No Data
                    </div>
                    <div style="font-size:17px;color:black;" v-else>{{ waterVol.slice(-1)[0].toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                  </v-card-text>
                </v-card>
              </div>
            </v-container>
          </v-card>
        </v-col>

        <div style="display: flex;">
          <v-col cols="6" align="center">
            <v-card class="pa-1">
              <v-container>
                <p align="center">Refilled</p>
                <v-card class="text-center" color="white" dark max-width="200" max-height="100">
                  <v-card-text>
                    <div style="font-size:12px;color:black;">
                      Recently
                    </div>
                    <div style="font-size:17px;color:black;" v-if="waterTank.length == 0">
                      No Data
                    </div>
                    <div style="font-size:17px;color:black;" v-else>{{ this.positiveSum }}<span style="font-size:15px;color:black;">mm</span></div>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-card>
          </v-col>

          <v-col cols="6" align="center">
            <v-card class="pa-1">
              <v-container>
                <p align="center">Consumption</p>
                <v-card class="text-center" color="white" dark max-width="200" max-height="100">
                  <v-card-text>
                    <div style="font-size:12px;color:black;">
                      Recently
                    </div>
                    <div style="font-size:17px;color:black;" v-if="waterTank.length == 0">
                      No Data
                    </div>
                    <div style="font-size:17px;color:black;" v-else>{{ this.negativeSum }}<span style="font-size:15px;color:black;">mm</span></div>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-card>
          </v-col>
        </div>

        <div style="display: flex;">
          <v-col cols="6" align="center">
            <v-card class="pa-1">
              <v-container>
                <p style="font-size: 16px" align="center">
                  Total Collected Rain Water
                </p>
                <v-card class="text-center" color="white" dark max-width="200" max-height="100">
                  <v-card-text>
                    <div style="font-size:12px;color:black;">
                      Recently(Max)
                    </div>
                    <div style="font-size:17px;color:black;" v-if="waterTank.length == 0">
                      No Data
                    </div>
                    <div style="font-size:17px;color:black;" v-else>{{ Math.max.apply(Math, this.waterSub) }}<span style="font-size:15px;color:black;">mm</span></div>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-card>
          </v-col>

          <v-col cols="6" align="center">
            <v-card class="pa-1">
              <v-container>
                <p style="font-size: 16px" align="center">
                  Total Consumed Rain Water
                </p>
                <v-card class="text-center" color="white" dark max-width="200" max-height="100">
                  <v-card-text>
                    <div style="font-size:12px;color:black;">
                      Recently(Max)
                    </div>
                    <div style="font-size:17px;color:black;" v-if="waterTank.length == 0">
                      No Data
                    </div>
                    <div style="font-size:17px;color:black;" v-else>{{ Math.min.apply(Math, this.waterSub) }}<span style="font-size:15px;color:black;">mm</span></div>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-card>
          </v-col>
        </div>
      </v-col>
    </v-row>

    <div>
      <div class="mx-auto text-center" v-if="waterTank.length == 0">
        No Data
      </div>
      <apexchart height="300" :options="waterLevelChart" :series="waterLevelSeries" v-else></apexchart>
    </div>

    <div>
      <div class="mx-auto text-center" v-if="waterTank.length == 0">
        No Data
      </div>
      <apexchart height="300" :options="sufWaterLevelChart" :series="sufWaterLevelSeries" v-else></apexchart>
    </div>
  </v-container>

  <div v-else>
    <div class="mt-5 pa-1" justify="center" align="center">
      <div class="pa-1">
        <v-select
          :items="location"
          item-value="_id"
          v-model="locationItem"
          @change="updateLocation"
          hide-details
          :item-text="
            (location) => {
              return location.location;
            }
          "
          prepend-inner-icon="mdi-map-marker"
          solo
          style="font-size: 15px;"
        ></v-select>
      </div>
      <div class="pa-1">
        <v-card style="text-align:left; display:flex; justify-content:space-between;">
          <v-md-date-range-picker :presets="presets" opens="right" @change="updateData">
            <v-card class="pa-3" slot="input" flat>
              <v-icon color="red darken-2"> mdi-clock-outline </v-icon><span style="font-size: 12px; margin-left: .5rem;">{{ formatDate($store.state.dateTime1) }} - {{ formatDate($store.state.dateTime2) }}</span>
            </v-card>
          </v-md-date-range-picker>
        </v-card>
      </div>
    </div>
    <v-row justify="center" align="center" class="mt-10 mb-10">
      <div class="water-tank mobile" v-if="waterTank.length == 0">
        <p justify="center" align="center">No Data</p>
        <div class="indicator" data-value="75"></div>
        <div class="indicator" data-value="50"></div>
        <div class="indicator" data-value="25"></div>
      </div>

      <div class="water-tank mobile" v-else>
        <div class="liquid" :style="cssProps">
          <p justify="center" align="center">{{ waterPercent.slice(-1)[0].toFixed(2) }}% / 2440ℓ</p>
          <svg class="water" viewBox="0 0 200 100">
            <defs>
              <linearGradient id="waterGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0" style="stop-color:#29ABE2" />
                <stop offset="0.1643" style="stop-color:#28A6E3" />
                <stop offset="0.3574" style="stop-color:#2496E6" />
                <stop offset="0.5431" style="stop-color:#1E7DEA" />
                <stop offset="0.7168" style="stop-color:#1559F0" />
                <stop offset="0.874" style="stop-color:#0B2CF7" />
                <stop offset="1" style="stop-color:#0000FF" />
              </linearGradient>
            </defs>
            <path
              fill="url(#waterGradient)"
              d="
        M 0,0 v 100 h 200 v -100 
        c -10,0 -15,5 -25,5 c -10,0 -15,-5 -25,-5
        c -10,0 -15,5 -25,5 c -10,0 -15,-5 -25,-5
        c -10,0 -15,5 -25,5 c -10,0 -15,-5 -25,-5
        c -10,0 -15,5 -25,5 c -10,0 -15,-5 -25,-5
      "
            />
          </svg>
        </div>

        <div class="indicator" data-value="75"></div>
        <div class="indicator" data-value="50"></div>
        <div class="indicator" data-value="25"></div>

        <div class="label" :style="cssProps" v-if="waterPercent.slice(-1)[0] < 60" style="color: green">{{ waterPercent.slice(-1)[0].toFixed(2) }}%</div>
        <div class="label" :style="cssProps" v-else-if="waterPercent.slice(-1)[0] >= 60 && waterPercent.slice(-1)[0] < 80" style="color: yellow">{{ waterPercent.slice(-1)[0].toFixed(2) }}%</div>
        <div class="label" :style="cssProps" v-else-if="waterPercent.slice(-1)[0] >= 80" style="color: crimson">{{ waterPercent.slice(-1)[0].toFixed(2) }}%</div>
      </div>
    </v-row>

    <v-col>
      <v-col cols="12">
        <v-card class="pa-1">
          <v-container style="display: flex; flex-direction:column; justify-content: space-between;">
            <p align="center" style="font-size:15px;">Current Tank Level</p>
            <div style="display: flex; justify-content: space-between;">
              <v-card class="text-center" color="white" dark width="180" max-height="100">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recently
                  </div>
                  <div style="font-size:15px;color:black;" v-if="waterTank.length == 0">
                    No Data
                  </div>
                  <div style="font-size:15px;color:black;" v-else>{{ waterConv[0] }}<span style="font-size:15px;color:black;">mm</span></div>
                </v-card-text>
              </v-card>

              <v-card class="text-center" color="white" dark width="180" max-height="100">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Filled
                  </div>
                  <div style="font-size:15px;color:black;" v-if="waterTank.length == 0">
                    No Data
                  </div>
                  <div style="font-size:15px;color:black;" v-else>{{ waterPercent.slice(-1)[0].toFixed(2) }}<span style="font-size:15px;color:black;">%</span></div>
                </v-card-text>
              </v-card>

              <v-card class="text-center" color="white" dark width="180" max-height="100">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Volume
                  </div>
                  <div style="font-size:15px;color:black;" v-if="waterTank.length == 0">
                    No Data
                  </div>
                  <div style="font-size:15px;color:black;" v-else>{{ waterVol.slice(-1)[0].toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                </v-card-text>
              </v-card>
            </div>
          </v-container>
        </v-card>
      </v-col>

      <div style="display: flex;">
        <v-col cols="6" align="center">
          <v-card class="pa-1">
            <v-container>
              <p align="center" style="font-size:15px;">Refilled</p>
              <v-card class="text-center" color="white" dark max-width="200" max-height="100">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recently
                  </div>
                  <div style="font-size:15px;color:black;" v-if="waterTank.length == 0">
                    No Data
                  </div>
                  <div style="font-size:15px;color:black;" v-else>{{ this.positiveSum }}<span style="font-size:15px;color:black;">mm</span></div>
                </v-card-text>
              </v-card>
            </v-container>
          </v-card>
        </v-col>

        <v-col cols="6" align="center">
          <v-card class="pa-1">
            <v-container>
              <p align="center" style="font-size:15px;">Consumption</p>
              <v-card class="text-center" color="white" dark max-width="200" max-height="100">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recently
                  </div>
                  <div style="font-size:15px;color:black;" v-if="waterTank.length == 0">
                    No Data
                  </div>
                  <div style="font-size:15px;color:black;" v-else>{{ this.negativeSum }}<span style="font-size:15px;color:black;">mm</span></div>
                </v-card-text>
              </v-card>
            </v-container>
          </v-card>
        </v-col>
      </div>

      <div style="display: flex;">
        <v-col cols="6" align="center">
          <v-card class="pa-1">
            <v-container>
              <p style="font-size: 15px" align="center">
                Total Collected Rain Water
              </p>
              <v-card class="text-center" color="white" dark max-width="200" max-height="100">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recently(Max)
                  </div>
                  <div style="font-size:15px;color:black;" v-if="waterTank.length == 0">
                    No Data
                  </div>
                  <div style="font-size:15px;color:black;" v-else>{{ Math.max.apply(Math, this.waterSub) }}<span style="font-size:15px;color:black;">mm</span></div>
                </v-card-text>
              </v-card>
            </v-container>
          </v-card>
        </v-col>

        <v-col cols="6" align="center">
          <v-card class="pa-1">
            <v-container>
              <p style="font-size: 15px" align="center">
                Total Consumed Rain Water
              </p>
              <v-card class="text-center" color="white" dark max-width="200" max-height="100">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recently(Max)
                  </div>
                  <div style="font-size:15px;color:black;" v-if="waterTank.length == 0">
                    No Data
                  </div>
                  <div style="font-size:15px;color:black;" v-else>{{ Math.min.apply(Math, this.waterSub) }}<span style="font-size:15px;color:black;">mm</span></div>
                </v-card-text>
              </v-card>
            </v-container>
          </v-card>
        </v-col>
      </div>
    </v-col>

    <div>
      <div class="mx-auto text-center" v-if="waterTank.length == 0">
        No Data
      </div>
      <apexchart height="220" :options="waterLevelChart" :series="waterLevelSeries" v-else></apexchart>
    </div>

    <div>
      <div class="mx-auto text-center" v-if="waterTank.length == 0">
        No Data
      </div>
      <apexchart height="220" :options="sufWaterLevelChart" :series="sufWaterLevelSeries" v-else></apexchart>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import axios from "axios";
  import moment from "moment";
  import VueApexCharts from "vue-apexcharts";

  Vue.component("apexchart", VueApexCharts);

  export default {
    data: () => ({
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Water Level Tank",
          disabled: true,
          href: "",
        },
        {
          text: "Overview",
          disabled: true,
          href: "",
        },
      ],
      // values1: moment().subtract(24, "hour"),
      // values2: moment(),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment()],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment()],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment()],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [
            moment()
              .clone()
              .startOf("week"),
            moment()
              .clone()
              .endOf("week"),
          ],
        },
        {
          label: "Last Week",
          range: [
            moment()
              .subtract(1, "weeks")
              .startOf("week"),
            moment()
              .subtract(1, "week")
              .endOf("week"),
          ],
        },
        {
          label: "This Month",
          range: [moment().startOf("month"), moment().endOf("month")],
        },
        {
          label: "Last Month",
          range: [moment().subtract(2, "month"), moment().subtract(1, "month")],
        },
      ],
      timer: true,
      loader: null,
      loading5: false,
      isMobile: true,
      location: [],
      locationItem: [],
      waterTank: [],
      waterLevel: [],
      waterSub: [],
      waterPercent: [],
      waterVol: [],

      waterLevelChart: {
        chart: {
          width: "100%",
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          position: "top",
        },
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
      },
      WaterLevelSeries: [
        {
          data: [],
        },
      ],
      sufWaterLevelChart: {
        chart: {
          width: "100%",
          type: "bar",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "top",
        },
        colors: [
          function({ value }) {
            if (value < 0) {
              return "#FF0000";
            } else {
              return "#008efa";
            }
          },
        ],
      },
      sufWaterLevelSeries: [
        {
          data: [],
        },
      ],
    }),
    computed: {
      cssProps() {
        return {
          "--top": this.waterPercent.slice(-1)[0] + "%",
        };
      },
    },
    mounted() {
      this.loadsBoard();
      this.loadsLocation();
      this.onResize();
      window.addEventListener("resize", this.onResize, { passive: true });
    },
    methods: {
      intervalFetchData: function() {
        setInterval(() => {
          if (this.timer == true) {
            this.loadsCo2(), this.loadsWeather();
          }
        }, 300000);
      },
      onResize() {
        this.isMobile = window.innerWidth < 700;
      },
      formatDate(value) {
        return moment(value).format("D MMM YYYY, h:mm:ss a");
      },
      loadsLocation: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/location-water-tank";
        axios
          .get(apiURL)
          .then((res) => {
            this.location = res.data;
            this.locationItem = this.location[0]._id;
            this.loadsBoard();
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsBoard: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/water-tank/" + this.locationItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.waterTank = res.data;
            this.waterLevel = res.data.map((water) => water.fields.water_level);
            this.waterConv = this.waterLevel.map((x) => 2057 - x);
            this.waterSub = this.waterConv.slice(1).map((v, i) => v - this.waterConv[i]);
            this.waterPercent = this.waterConv.map((x) => (x / 2057) * 100);
            this.waterVol = this.waterConv.map((x) => (x * 1220 * 3660) / 1000000);
            this.positive = this.waterSub.filter((posNumber) => posNumber >= 0);
            this.negative = this.waterSub.filter((negNumber) => negNumber < 0);
            this.positiveSum = this.positive.reduce((sumSoFar, current) => sumSoFar + current, 0);
            this.negativeSum = this.negative.reduce((sumSoFar, current) => sumSoFar + current, 0);

            let waterLevelFormat = this.waterTank.map((e, i) => {
              return {
                x: e.timestamp,
                y: this.waterConv[i],
              };
            });

            this.waterLevelSeries = [
              {
                name: "Water Tank Level",
                data: waterLevelFormat,
              },
            ];

            let sufWaterLevelFormat = this.waterTank.map((e, i) => {
              return {
                x: e.timestamp,
                y: this.waterSub[i],
              };
            });

            this.sufWaterLevelSeries = [
              {
                name: "Water Level Distance in mm",
                data: sufWaterLevelFormat,
              },
            ];
          })
          .catch((error) => {
            console.log(error);
          });
      },
      updateData(values) {
        this.values1 = values[0];
        this.values2 = values[1];
        this.$store.commit("setDateTime1", this.values1);
        this.$store.commit("setDateTime2", this.values2);
        this.loadsBoard();
      },
      updateLocation() {
        this.loadsBoard();
      },
    },
    beforeDestroy() {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", this.onResize, { passive: true });
      }
    },
    watch: {
      loader() {
        const l = this.loader;
        this[l] = !this[l];

        setTimeout(() => (this[l] = false), 500);

        this.loader = null;
      },
    },
  };
</script>

<style scoped>
  .water-tank {
    width: 300px;
    height: 300px;
    border: 0.3em solid #3a3a3a;
    border-top: none;
    box-sizing: border-box;
    position: relative;
  }
  .mobile {
    width: 220px;
    height: 250px;
    border: 0.3em solid #3a3a3a;
    border-top: none;
    box-sizing: border-box;
    position: relative;
  }

  .water-tank .liquid {
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: hidden;
  }

  .water-tank .liquid svg {
    height: 30em;
    top: calc(97.5% - 57%);
    top: calc(100% - var(--top));
    position: absolute;
    animation: waves 8s infinite linear;
  }

  .df {
    display: flex;
    justify-content: center;
  }

  @keyframes waves {
    0% {
      transform: translateX(-15em);
    }
    100% {
      transform: translateX(0);
    }
  }

  .water-tank .label {
    position: absolute;
    color: white;
    line-height: 2em;
    width: 4em;
    text-align: center;
    border-radius: 0.5em;
    margin-bottom: -1em;
    background-color: #3a3a3a;
    right: -4.9em;
    bottom: 57%;
    bottom: var(--top);
  }

  .water-tank .label:before {
    content: "";
    position: absolute;
    background-color: #3a3a3a;
    width: 0.7em;
    height: 0.7em;
    top: 0.65em;
    left: -0.3em;
    transform: rotate(45deg);
  }

  .water-tank .indicator {
    position: absolute;
    background-color: #3a3a3a;
    height: 0.3em;
    width: 1em;
    margin-bottom: -0.15em;
    right: 0;
  }

  .water-tank .indicator[data-value="25"] {
    bottom: 25%;
  }

  .water-tank .indicator[data-value="50"] {
    bottom: 50%;
  }

  .water-tank .indicator[data-value="75"] {
    bottom: 75%;
  }
</style>
